import { RPInstance } from './base';
import store from '@/store';

// 출금 관련 API
const exchangeApi = {};

const getBaseUrl = () => {
  const serviceUrl = store.getters['serviceUrl'];
  return serviceUrl;
};

// [KRPC]
// 포인트 전환 가능 여부 체크
exchangeApi.checkExchange = () => {
  const baseUrl = getBaseUrl();
  return RPInstance.get(`${baseUrl}/exchange/check`);
};

// 포인트 전환 관련 정보 조회 (min/max, 환율 등)
exchangeApi.getExchangeInfo = () => {
  const baseUrl = getBaseUrl();
  return RPInstance.get(`${baseUrl}/exchange/info`);
};

// 넥슨포인트 전환 관련 정보 조회 (min/max, 환율 등)
exchangeApi.getExchangeNexonPointInfo = () => {
  const baseUrl = getBaseUrl();
  return RPInstance.get(`${baseUrl}/exchange/nexon-point/info`);
};

// 포인트 전환 신청 내역
exchangeApi.getExchangeHistory = (val) => {
  const baseUrl = getBaseUrl();
  return RPInstance.get(`${baseUrl}/exchange/history`, { params: val });
};

// 포인트 전환 가능 여부 체크 및 init page
exchangeApi.getExchangeInit = (val) => {
  const baseUrl = getBaseUrl();
  const params = {
    point: val,
  };
  return RPInstance.get(`${baseUrl}/exchange/init`, { params });
};

// 포인트 전환 신청
exchangeApi.setExchangeRequest = (val) => {
  const baseUrl = getBaseUrl();
  return RPInstance.post(`${baseUrl}/exchange/request`, val);
};

// 포인트 전환 신청된 정보 변경
exchangeApi.setExchangeAccountRegist = (val) => {
  const baseUrl = getBaseUrl();
  return RPInstance.put(`${baseUrl}/exchange/request`, val);
};

// 포인트 전환 방법 알아보기 안내사항 조회
exchangeApi.getKrpcNotice = (val) => {
  const baseUrl = getBaseUrl();
  return RPInstance.get(`${baseUrl}/exchange/krpc/notice`, val);
};

// 포인트 전환을 위한 은행 목록 조회
exchangeApi.getBankList = () => {
  return RPInstance.get(`common/mypage/bank`);
};

// [GLOBAL]
// 글로벌 출금 가능 여부 체크
exchangeApi.checkGlobalExchange = () => {
  const baseUrl = getBaseUrl();
  return RPInstance.get(`${baseUrl}/global/withdraw/check`);
};

// nj 넥슨 포인트 전환 가능 여부 체크
exchangeApi.checkGlobalExchangeNexonPoint = () => {
  const baseUrl = getBaseUrl();
  return RPInstance.get(`${baseUrl}/global/withdraw/nexon-point/check`);
};

// 글로벌 출금 페이지 조회 (예약)
exchangeApi.reserveWithdraw = (val) => {
  const baseUrl = getBaseUrl();
  return RPInstance.post(`${baseUrl}/global/withdraw/reservation`, val);
};

// 글로벌 출금 실행
exchangeApi.excutionWithdraw = (val) => {
  const baseUrl = getBaseUrl();
  return RPInstance.post(`${baseUrl}/global/withdraw/execution`, val);
};

// NJ 넥슨 포인트 전환 신청
exchangeApi.requestNexonPointWithdraw = (val) => {
  const baseUrl = getBaseUrl();
  return RPInstance.post(`${baseUrl}/global/withdraw/nexon-point/request`, val);
};

// 글로벌 출금 내역 조회
exchangeApi.getGlobalExchangeHistory = (val) => {
  const baseUrl = getBaseUrl();
  return RPInstance.get(`${baseUrl}/global/withdraw/history`, { params: val });
};

// 글로벌 출금 내역 상세 조회 (티팔티 출금 정보)
exchangeApi.getGlobalExchangeHistoryDetail = (val) => {
  const baseUrl = getBaseUrl();
  return RPInstance.get(`${baseUrl}/global/withdraw/history/detail`, { params: val });
};

// 글로벌 출금 신청 정책 및 안내사항 조회
exchangeApi.getGlobalNotice = (val) => {
  const baseUrl = getBaseUrl();
  return RPInstance.get(`${baseUrl}/exchange/global/notice`, val);
};

export default {
  ...exchangeApi,
};
